import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "./registerServiceWorker";
import Notifications from "vue-notification";
Vue.use(Notifications);

Vue.config.productionTip = false;

if (location.hostname === "v5.uniauc.com") {
  global.baseAPIURL = "https://api.uniauc.com";
  global.baseWSURL = "wss://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
} else if (location.hostname === "admin.uniauc.com") {
  global.baseAPIURL = "https://api.uniauc.com";
  global.baseWSURL = "wss://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
} else if (location.hostname === "localhost") {
  // global.baseAPIURL = "https://api.uniauc.com";
  global.baseAPIURL = "http://localhost:4003";
  global.baseWSURL = "wss://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
} else {
  global.baseAPIURL = "https://api.uniauc.com";
  global.baseWSURL = "wss://api.uniauc.com";
  axios.defaults.baseURL = global.baseAPIURL;
}

global.siteId = "uniauc";

import Vue2Filters from 'vue2-filters'
Vue.use(Vue2Filters)

import VueI18n from "vue-i18n";
import { BootstrapVue, IconsPlugin } from 'bootstrap-vue'
import axios from "axios";
import moment from "moment-timezone";
moment.locale("kr", {
  months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split(
    "_"
  ),
  monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split(
    "_"
  ),
  monthsParseExact: true,
  weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"),
  weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"),
  weekdaysMin: "Di_Lu_Ma_Me_Je_Ve_Sa".split("_"),
  weekdaysParseExact: true,
  longDateFormat: {
    LT: "HH:mm",
    LTS: "HH:mm:ss",
    L: "YYYY-MM-DD",
    LL: "D MMMM YYYY",
    LLL: "D MMMM YYYY HH:mm",
    LLLL: "dddd D MMMM YYYY HH:mm"
  }
});
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

Vue.use(VueI18n);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);

import VueMeta from 'vue-meta'

Vue.use(VueMeta)


Vue.mixin({
  data() {
    return {
      $site: "un"
    };
  },
  methods: {
    $sleep: async function(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
    },
    $get: async function(url, arg) {
      return (await axios.get(url, arg)).data;
    },
    $post: async function(url, arg) {
      return (await axios.post(url, arg)).data;
    },
    $warn(text,duration=3000) {
      console.log("warning");

      return Vue.notify({ type: "warn", duration, text: `<h3>${text}</h3>` });
    }
  }
})

if (process.env.NODE_ENV === "development") {
  global.baseURL = "http://localhost:4003";
  global.baseWSURL = "ws://localhost:4003";
} else {
  global.baseURL = "https://api.uniauc.com";
  global.basePHPURL = "https://www.uniauc.com";
  global.baseWSURL = "wss://ws.uniauc.com";
}

axios.defaults.baseURL = global.baseURL;
axios.defaults.withCredentials = true;

axios.interceptors.response.use(function (response) {
  return response
}, function (error) {
  console.log(error.response.data)
  if (error.response.status === 401) {
    store.dispatch('logout')
    router.push('/login')
  }
  return Promise.reject(error)
})

global.$get = async function(url, arg) {
  return (await axios.get(url, arg)).data;
};
global.$post = async function(url, arg) {
  return (await axios.post(url, arg)).data;
};
window.log = console.log.bind(console, "DEBUG:");

const messages = {
  en: {
    message: {
      hello: "hello world"
    }
  },
  ja: {
    message: {
      hello: "こんにちは、世界"
    }
  }
};

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: "ja", // set locale
  messages // set locale messages
});

new Vue({
  i18n,
  router,
  store,
  render: h => h(App)
}).$mount("#app");
